import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { connect, useDispatch } from 'react-redux';
import NotificationType from './NotificationType';
import './ManageNotification.scss';
import {
  getMarketingSubscriptionDataFunc,
  saveMarketingSubscriptionDataFunc,
  setToastMessage,
} from '../../../actionCreators/common';
import BootstrapSuccessError from '../MyAccount/BootstrapSuccessError';

const ManageNotification = props => {
  const dispatch = useDispatch();
  const {
    dataLocale,
    userInfo,
    getMarketingSubscriptionDataSuccess,
    getMarketingSubscriptionData,
    getMarketingSubscriptionDataFail,
    getMarketingSubscriptionDataError,
    saveMarketingSubscriptionDataFunc,
    setToastMessage,
    marketingSubscriptionSuccess,
  } = props;
  const {
    MANAGE_NOTIFICATIONS,
    WHATSAPP_NOTIFICATION,
    SMS_NOTIFICATION,
    PUSH_NOTIFICATION,
    EMAIL_NOTIFICATION,
    SAVE,
    YOUR_PREFERNCES_SAVE_SUCCESSFULLY,
    MARKETING_CHANNEL_PERMISSIONS,
    MANAGE_COMMUNICATION_PREFERENCES,
    STANDARDPARAMS,
  } = dataLocale;
  const [whatsAppNotification, setWhatsAppNotification] = useState();
  const [smsNotification, setSMSNotification] = useState();
  const [pushNotification, setPushNotification] = useState();
  const [emailNotifiacation, setEmailNotification] = useState();
  const [notificationObj, setNotificationObj] = useState({});
  const [subscriptionSuccess, setSubscriptionSuccess] = useState();
  const [saveSubscription, setSaveSubScription] = useState();
  const trackingDetail = () => {
    const dlUpdate = {
      event: STANDARDPARAMS,
      PageUrl: location.href,
      pageType: MANAGE_COMMUNICATION_PREFERENCES,
      mobile: btoa(userInfo?.telephone || ''),
      email: btoa(userInfo?.email || ''),
      loginStatus: userInfo?.login,
      lkUserType: userInfo?.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
      customerId: userInfo?.id,
      countryCode: userInfo?.countryCode,
    };
    if (typeof window.dataLayer !== 'undefined') window.dataLayer.push(dlUpdate);
    else {
      setTimeout(() => {
        window.dataLayer.push(dlUpdate);
      }, 2000);
    }
  };

  const gaTrackingOnSaveClick = (
    whatsappSubscription,
    emailSubscription,
    smsSubscription,
    pushNotificationSubscription
  ) => {
    const dlUpdate = {
      event: MARKETING_CHANNEL_PERMISSIONS,
      emailPermission: emailSubscription ? 'Active' : 'Inactive',
      smsPermission: smsSubscription ? 'Active' : 'Inactive',
      pushNotificationPermission: pushNotificationSubscription ? 'Active' : 'Inactive',
      whatsappPermission: whatsappSubscription ? 'Active' : 'Inactive',
    };
    if (typeof window.dataLayer !== 'undefined') window.dataLayer.push(dlUpdate);
    else {
      setTimeout(() => {
        window.dataLayer.push(dlUpdate);
      }, 2000);
    }
  };

  useEffect(() => {
    dispatch(getMarketingSubscriptionDataFunc());
  }, []);

  useEffect(() => {
    if (getMarketingSubscriptionDataSuccess) {
      setNotificationObj(getMarketingSubscriptionData);
      setWhatsAppNotification(getMarketingSubscriptionData?.whatsapp);
      setPushNotification(getMarketingSubscriptionData?.pushNotification);
      setSMSNotification(getMarketingSubscriptionData?.sms);
      setEmailNotification(getMarketingSubscriptionData?.email);
      trackingDetail();
      if (typeof window.clevertap !== 'undefined') {
        window.clevertap.event.push('Page Visited', {
          'Page Name': MANAGE_COMMUNICATION_PREFERENCES,
          Phone: `${userInfo?.phoneCode}${userInfo?.telephone}`,
        });
        window.clevertap.onUserLogin.push({
          Site: {
            name: `${userInfo?.firstName} ${userInfo?.lastName}`,
            Identity: userInfo?.telephone,
            Email: userInfo?.email,
            Phone: `${userInfo?.phoneCode || ''}${userInfo?.telephone || ''}`,
            'MSG-email': getMarketingSubscriptionData?.email,
            'MSG-push': getMarketingSubscriptionData?.pushNotification,
            'MSG-sms': getMarketingSubscriptionData?.sms,
            'MSG-whatsapp': getMarketingSubscriptionData?.whatsapp,
          },
        });
      }
    } else if (getMarketingSubscriptionDataFail && getMarketingSubscriptionDataError) {
      setToastMessage({ message: getMarketingSubscriptionDataError, warning: true });
    }
  }, [getMarketingSubscriptionDataSuccess]);

  const handleWhatsAppNotification = () => {
    setWhatsAppNotification(!whatsAppNotification);
    setNotificationObj({ ...notificationObj, whatsapp: !whatsAppNotification });
  };
  const handleSMSNotification = () => {
    setSMSNotification(!smsNotification);
    setNotificationObj({ ...notificationObj, sms: !smsNotification });
  };

  const handlePushNotification = () => {
    setPushNotification(!pushNotification);
    setNotificationObj({ ...notificationObj, pushNotification: !pushNotification });
  };

  const handleEmailNotification = () => {
    setEmailNotification(!emailNotifiacation);
    setNotificationObj({ ...notificationObj, email: !emailNotifiacation });
  };

  const updateNotification = () => {
    if (notificationObj) {
      saveMarketingSubscriptionDataFunc(notificationObj);
      setSubscriptionSuccess(false);
      setSaveSubScription(true);
    }
  };
  useEffect(() => {
    if (marketingSubscriptionSuccess && saveSubscription) {
      gaTrackingOnSaveClick(
        notificationObj?.whatsapp,
        notificationObj?.email,
        notificationObj?.sms,
        notificationObj?.pushNotification
      );
      if (typeof window.clevertap !== 'undefined') {
        window.clevertap.onUserLogin.push({
          Site: {
            'MSG-email': notificationObj?.email,
            'MSG-push': notificationObj?.pushNotification,
            'MSG-sms': notificationObj?.sms,
            'MSG-whatsapp': notificationObj?.whatsapp,
          },
        });
      }
      setSubscriptionSuccess(true);
      setSaveSubScription(false);
    }
  }, [marketingSubscriptionSuccess]);

  return (
    <React.Fragment>
      <Helmet title={MANAGE_NOTIFICATIONS} />
      {subscriptionSuccess && (
        <BootstrapSuccessError message={YOUR_PREFERNCES_SAVE_SUCCESSFULLY} type="success" />
      )}
      <h2>{MANAGE_NOTIFICATIONS}</h2>
      <NotificationType
        handleNotification={() => handleWhatsAppNotification()}
        notificationLogo="Whatsapp"
        notificationText={WHATSAPP_NOTIFICATION}
        setNotification={whatsAppNotification}
      />
      <NotificationType
        handleNotification={() => handleSMSNotification()}
        notificationLogo="Sms"
        notificationText={SMS_NOTIFICATION}
        setNotification={smsNotification}
      />
      <NotificationType
        handleNotification={() => handlePushNotification()}
        notificationLogo="PushNotification"
        notificationText={PUSH_NOTIFICATION}
        setNotification={pushNotification}
      />
      <NotificationType
        handleNotification={() => handleEmailNotification()}
        notificationLogo="EmailNotification"
        notificationText={EMAIL_NOTIFICATION}
        setNotification={emailNotifiacation}
      />
      <div className="btn-container-non-fixed">
        <button
          className="fsp18 fs18 fw500 text-uppercase bora-4"
          onClick={() => updateNotification()}
        >
          {SAVE}
        </button>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  dataLocale: state.locale,
  userInfo: state.common.userInfo?.result || state.common.userInfo,
  marketingSubscriptionSuccess: state.common.marketingSubscriptionSuccess,
  getMarketingSubscriptionData: state.common.getMarketingSubscriptionData,
  getMarketingSubscriptionDataSuccess: state.common.getMarketingSubscriptionDataSuccess,
  getMarketingSubscriptionDataFail: state.common.getMarketingSubscriptionDataFail,
  getMarketingSubscriptionDataError: state.common.getMarketingSubscriptionDataError,
});

function mapDispatchToProps(dispatch) {
  return {
    saveMarketingSubscriptionDataFunc: data => dispatch(saveMarketingSubscriptionDataFunc(data)),
    setToastMessage: toast => dispatch(setToastMessage(toast)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageNotification);
